import { CLOUDINARY_BASE_URL } from "../config/cloudinary";

const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;

const HIDDEN_BLOG_SLUGS = new Set([
  "jet-secret-beach-tour",
  "jet-private-secret-tour-experience",
]);
const HIDDEN_BLOG_TAGS = new Set(["#ジェット", "#ジェットツアー"]);

const isVisibleArticle = (article) => !HIDDEN_BLOG_SLUGS.has(article?.slug);

export const blogCategories = [
  { key: "girls", label: "女子旅", icon: "💎", path: "/blog/category/girls" },
  { key: "hotel", label: "ホテル", icon: "🏨", path: "/blog/category/hotel" },
  { key: "cafe", label: "カフェ", icon: "☕", path: "/blog/category/cafe" },
  { key: "beach", label: "ビーチ", icon: "🌴", path: "/blog/category/beach" },
  { key: "rainy", label: "雨の日", icon: "☂️", path: "/blog/category/rainy" },
  {
    key: "sunset",
    label: "サンセットスポット",
    icon: "🌅",
    path: "/blog/category/sunset",
  },
  {
    key: "spot",
    label: "映えスポット",
    icon: "📷",
    path: "/blog/category/spot",
  },
  {
    key: "shooting",
    label: "撮影",
    icon: "📸",
    path: "/blog/category/shooting",
  },
  {
    key: "star",
    label: "星空",
    icon: "🌌",
    path: "/blog/category/star",
  },
  { key: "drive", label: "ドライブ", icon: "🚙", path: "/blog/category/drive" },
  { key: "tour", label: "ツアー", icon: "🏄", path: "/blog/category/tour" },
  {
    key: "gourmet",
    label: "グルメ",
    icon: "🍴",
    path: "/blog/category/gourmet",
  },
  {
    key: "dinner",
    label: "夜ご飯",
    icon: "🍽️",
    path: "/blog/category/dinner",
  },
];

export const blogTags = [
  "#宮古島",
  "#宮古島女子旅",
  "#女子旅",
  "#一番綺麗な海",
  "#大人の海遊び",
  "#完全プライベート",
  "#観光マップに載ってない",
  "#ホテル",
  "#撮影",
  "#ドローン",
  "#SUP",
  "#秘境SUP",
  "#秘境",
  "#シークレットビーチ",
  "#マリンアクティビティ",
  "#サーフィン",
  "#グルメ",
  "#ランチ",
  "#夜ご飯",
  "#フルムーンパーティ",
  "#焼肉",
  "#宮古牛",
  "#宮古そば",
  "#サーターアンダギー",
  "#ジェラート",
  "#スイーツ",
  "#宮古島スイーツ",
  "#雨の日",
  "#室内体験",
  "#宮古島体験",
  "#レンタカー",
  "#格安レンタカー",
  "#映えスポット",
  "#絶景スポット",
  "#秘境フォトツアー",
  "#ビーチ",
  "#モデルコース",
  "#八重干瀬",
  "#星空撮影",
  "#星空",
  "#星空スポット",
  "#天の川",
  "#新月",
  "#サンセット",
  "#カフェ巡り",
  "#夜遊び",
  "#旅動画",
  "#ツアーの様子",
  "#非日常体験",
  "#映え",
  "#ショート動画",
].filter((tag) => !HIDDEN_BLOG_TAGS.has(tag));

export const blogTagLinks = blogTags.map((tag) => ({
  label: tag,
  key: tag.replace("#", ""),
  path: `/blog/tag/${encodeURIComponent(tag.replace("#", ""))}`,
}));

export const categoryArticles = {
  girls: [
    {
      id: "girls-1",
      slug: "girls-trip-photo-movie-miyakojima",
      category: "Girls Trip",
      title: "宮古島女子旅で絶対に残したい写真と映像",
      text: "宮古島 女子旅 写真で探している方へ。SUPでしか来れない秘境やシークレットビーチで、SNSに載せたくなる写真・動画を残す旅。",
      date: "2026.08.08",
      readTime: "5分",
      image: img("v1786120675/DSC00888_tk8uhe.webp"),
      tags: [
        "#宮古島",
        "#宮古島女子旅",
        "#女子旅",
        "#撮影",
        "#秘境SUP",
        "#シークレットビーチ",
        "#完全プライベート",
        "#非日常体験",
      ],
    },
    {
      id: "girls-2",
      slug: "girls-trip-model-course-2n3d",
      category: "Girls Trip",
      title: "宮古島で映え女子旅！ 2泊3日のモデルコース",
      text: "カフェ、ビーチ、サンセット、秘境SUPまで。宮古島 女子旅 映えスポットを無理なく巡るモデルコース。",
      date: "2026.08.08",
      readTime: "6分",
      image: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
      tags: [
        "#宮古島",
        "#宮古島女子旅",
        "#女子旅",
        "#モデルコース",
        "#映えスポット",
        "#撮影",
      ],
    },
    {
      id: "girls-3",
      slug: "miyakojima-girls-trip-spots",
      category: "Girls Trip",
      title: "宮古島周辺でおすすめの女子旅スポット",
      text: "SNS映えする海、カフェ、サンセット、観光マップに載っていない場所まで女子旅向けに紹介。",
      date: "2026.08.08",
      readTime: "6分",
      image: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
      tags: [
        "#宮古島",
        "#宮古島女子旅",
        "#女子旅",
        "#映えスポット",
        "#観光マップに載ってない",
      ],
    },
    {
      id: "girls-4",
      slug: "hidden-sup-tour-experience",
      category: "Girls Trip",
      title: "SUPでしか来れない秘境SUPツアーの様子",
      text: "完全プライベートで楽しむ、少し大人な海遊び。宮古島 秘境SUPの雰囲気を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1785005393/DSC00191_small_lhfvnk.jpg"),
      tags: [
        "#宮古島",
        "#秘境SUP",
        "#SUP",
        "#大人の海遊び",
        "#完全プライベート",
        "#非日常体験",
      ],
    },
  ],

  cafe: [
    {
      id: "cafe-1",
      slug: "cafe",
      category: "Cafe",
      title: "宮古島のおすすめ厳選カフェ",
      text: "海が見える絶景カフェ、緑に囲まれたカフェ、雨の日でも楽しめるカフェを紹介。",
      date: "2026.06.27",
      readTime: "8分",
      image: img(
        "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
      ),
      tags: ["#宮古島", "#カフェ巡り", "#映えスポット"],
    },
    {
      id: "cafe-4",
      slug: "bae-cafe-best5",
      category: "Cafe",
      title: "写真撮るならここ！映えるカフェBEST6",
      text: "宮古島で写真や動画に残したい、海・緑・南国感がきれいに映えるカフェを厳選。",
      date: "2026.07.22",
      readTime: "6分",
      image: img(
        "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
      ),
      tags: ["#宮古島", "#カフェ巡り", "#映えスポット", "#撮影"],
    },
    {
      id: "cafe-2",
      slug: "cafe",
      category: "Cafe",
      title: "海が見えるオーシャンビューカフェ",
      text: "宮古ブルーを眺めながらゆっくり過ごせる、旅の途中に寄りたいカフェ。",
      date: "2026.06.27",
      readTime: "5分",
      image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
      tags: ["#宮古島", "#カフェ巡り", "#映えスポット"],
    },
    {
      id: "cafe-3",
      slug: "cafe",
      category: "Cafe",
      title: "雨の日でも楽しめる宮古島カフェ",
      text: "天気が悪い日でも、ゆっくり過ごせるカフェやスイーツスポットを紹介。",
      date: "2026.06.26",
      readTime: "4分",
      image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
      tags: ["#宮古島", "#カフェ巡り"],
    },
  ],

  beach: [
    {
      id: "beach-1",
      slug: "beach",
      category: "Beach",
      title: "初めての宮古島で行くべきビーチ10選",
      text: "与那覇前浜、砂山、渡口の浜など、初めてでも外さないビーチを紹介。",
      date: "2026.06.17",
      readTime: "6分",
      image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
      tags: ["#宮古島", "#ビーチ", "#映えスポット"],
    },
    {
      id: "beach-2",
      slug: "beach",
      category: "Beach",
      title: "写真が映える宮古島ビーチまとめ",
      text: "白砂、透明度、海のグラデーションが綺麗に見えるスポットを厳選。",
      date: "2026.06.16",
      readTime: "5分",
      image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
      tags: ["#宮古島", "#ビーチ", "#撮影", "#映え"],
    },
    {
      id: "beach-3",
      slug: "snorkel",
      category: "Beach",
      title: "ウミガメに会えるシュノーケルスポット",
      text: "安全に楽しみながら、宮古島らしい海の世界を体験できる場所を紹介。",
      date: "2026.06.08",
      readTime: "4分",
      image: img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg"),
      tags: ["#宮古島", "#ビーチ", "#SUP"],
    },
  ],

  rainy: [
    {
      id: "rainy-1",
      slug: "rainy-day-plan",
      category: "Rainy Day",
      title: "雨の日でも楽しめる宮古島の室内体験",
      text: "レジンアート、シーサー作り、パーマネントジュエリー、カスタムアクセサリー作りを紹介。",
      date: "2026.07.22",
      readTime: "6分",
      image: img("v1788261035/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-09-01_20.09.37_a4hlqg.png"),
      tags: ["#宮古島", "#雨の日", "#室内体験", "#宮古島体験"],
    },
  ],

  sunset: [
    {
      id: "sunset-1",
      slug: "sunset-spots-best5",
      category: "Sunset",
      title: "宮古島のおすすめサンセットスポット5選",
      text: "17END、佐和田の浜、トゥリバーなど、夕日が綺麗に見える場所を紹介。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
      tags: ["#宮古島", "#サンセット", "#撮影", "#旅動画"],
    },
  ],

  hotel: [
    {
      id: "hotel-guide-by-area-1",
      slug: "miyako-hotel-guide-by-area",
      category: "Hotel",
      title: "【エリア別】宮古島のおすすめホテル・リゾート",
      text: "伊良部島、シギラ・上野、平良・北部、来間島、与那覇前浜周辺までエリア別に紹介。",
      date: "2026.09.08",
      readTime: "10分",
      image: img("v1788839327/images_fzmtmq.jpg"),
      tags: ["#宮古島", "#宮古島ホテル", "#リゾート", "#ヴィラ"],
    },
  ],

  spot: [
    {
      id: "spot-girls-hotel-1",
      slug: "miyakojima-girls-trip-hotels",
      category: "Spot",
      title: "宮古島で女子旅におすすめのホテル6選",
      text: "写真映え、プール、オーシャンビュー、アクセスで選ぶ女子旅向けホテル。",
      date: "2026.08.08",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#女子旅", "#ホテル", "#非日常体験"],
    },
    {
      id: "spot-girls-spot-1",
      slug: "miyakojima-girls-trip-spots",
      category: "Spot",
      title: "宮古島周辺でおすすめの女子旅スポット",
      text: "ビーチ、橋、カフェ、サンセット、秘境SUPまで女子旅で行きたい場所を紹介。",
      date: "2026.08.08",
      readTime: "6分",
      image: img("v1784945639/DSC00440-2_syxyio.webp"),
      tags: ["#宮古島", "#女子旅", "#映えスポット", "#カフェ巡り", "#撮影"],
    },
    {
      id: "spot-1",
      slug: "spot",
      category: "Spot",
      title: "宮古島で映える絶景スポット7選",
      text: "写真や動画に残したい、宮古島らしい絶景スポットをまとめました。",
      date: "2026.06.20",
      readTime: "6分",
      image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
      tags: ["#宮古島", "#映えスポット", "#撮影"],
    },
    {
      id: "spot-2",
      slug: "spot",
      category: "Spot",
      title: "ドローンで撮りたい宮古ブルーの景色",
      text: "空から見た時に特に美しい、海のグラデーションが出る場所を紹介。",
      date: "2026.06.19",
      readTime: "5分",
      image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
      tags: ["#宮古島", "#ドローン", "#映えスポット"],
    },
  ],

  drive: [
    {
      id: "drive-girls-trip-1",
      slug: "girls-trip-model-course-2n3d",
      category: "Drive",
      title: "宮古島で映え女子旅！ 2泊3日のモデルコース",
      text: "写真・カフェ・ビーチ・サンセット・夜ご飯まで楽しむ女子旅モデルコース。",
      date: "2026.08.08",
      readTime: "6分",
      image: img("v1785776523/DSC00815_yry3re.webp"),
      tags: ["#宮古島", "#女子旅", "#モデルコース", "#映えスポット", "#撮影"],
    },
    {
      id: "drive-7",
      slug: "miyakojima-superb-view-spots",
      category: "Drive",
      title: "宮古島旅行で絶対に行きたい絶景スポット",
      text: "王道の絶景から秘境スポット、究極の非日常体験を残せる秘境フォトツアーまで紹介。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#絶景スポット", "#撮影", "#ドローン"],
    },
    {
      id: "drive-8",
      slug: "miyakojima-cheap-local-rentacar",
      category: "Drive",
      title: "宮古島 激安ローカルレンタカーまとめ",
      text: "宮古島で安く借りたい人向けに、ローカル系レンタカーと選ぶ時の注意点を紹介。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#レンタカー", "#格安レンタカー", "#ドライブ"],
    },
    {
      id: "drive-9",
      slug: "ultimate-extraordinary-miyakojima",
      category: "Drive",
      title: "全てを忘れ究極の非日常体験を求める方へ",
      text: "秘境の海、絶景撮影、SUP、ジェット、星空まで。宮古島の究極の過ごし方を紹介。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#非日常体験", "#秘境", "#秘境フォトツアー"],
    },
    {
      id: "drive-10",
      slug: "miyakojima-today-travel-dashboard",
      category: "Drive",
      title: "宮古島を120%楽しむために！今日チェックしたい旅情報",
      text: "天気、日の出・日の入り、月の出・月入り、潮位、星空指数など出発前に見る情報を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#天気", "#潮位", "#星空"],
    },
    {
      id: "drive-3",
      slug: "model-course-2n3d",
      category: "Drive",
      title: "宮古島2泊3日モデルプラン",
      text: "秘境フォトツアーや秘境SUP、八重干瀬、サンセット、夜ご飯まで楽しむ2泊3日プラン。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#ドライブ", "#モデルコース", "#八重干瀬"],
    },
    {
      id: "drive-4",
      slug: "model-course-3n4d",
      category: "Drive",
      title: "宮古島3泊4日モデルプラン",
      text: "秘境フォトツアー、秘境SUP、八重干瀬、星空撮影まで無理なく楽しむ3泊4日プラン。",
      date: "2026.07.31",
      readTime: "7分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#ドライブ", "#モデルコース", "#星空撮影"],
    },
    {
      id: "drive-1",
      slug: "drive",
      category: "Drive",
      title: "車で行ける絶景スポット7選",
      text: "ドライブ途中に立ち寄りたい、絶景が楽しめるスポットを厳選。",
      date: "2026.06.20",
      readTime: "6分",
      image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
      tags: ["#宮古島", "#映えスポット", "#ドローン"],
    },
    {
      id: "drive-2",
      slug: "drive",
      category: "Drive",
      title: "宮古島ドライブ1日モデルコース",
      text: "朝から夕方まで、海・カフェ・サンセットを楽しむドライブプラン。",
      date: "2026.06.19",
      readTime: "7分",
      image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
      tags: ["#宮古島", "#サンセット"],
    },
  ],

  tour: [
    {
      id: "tour-9",
      slug: "miyakojima-surfing-guide",
      category: "Tour",
      title: "宮古島来たらサーフィンしないと！",
      text: "サンライズ、初心者レッスン、多言語対応、ローカルガイドの安心感まで。宮古島サーフィン体験を動画で紹介。",
      date: "2026.09.01",
      readTime: "5分",
      image: img("v1788264796/IMG_6101_wqf7cj.jpg"),
      tags: [
        "#宮古島",
        "#宮古島サーフィン",
        "#サーフィン",
        "#マリンアクティビティ",
        "#ローカルガイド",
        "#多言語対応",
        "#撮影",
      ],
    },
    {
      id: "tour-8",
      slug: "girls-trip-photo-movie-miyakojima",
      category: "Tour",
      title: "宮古島女子旅で絶対に残したい写真と映像",
      text: "宮古島 女子旅 写真で探している方へ。SUPでしか来れない秘境やシークレットビーチで、SNSに載せたくなる写真・動画を残す旅。",
      date: "2026.08.08",
      readTime: "5分",
      image: img("v1786120675/DSC00888_tk8uhe.webp"),
      tags: [
        "#宮古島",
        "#宮古島女子旅",
        "#女子旅",
        "#撮影",
        "#秘境SUP",
        "#秘境",
        "#SUP",
        "#シークレットビーチ",
        "#完全プライベート",
        "#非日常体験",
        "#映え",
      ],
    },
    {
      id: "tour-3",
      slug: "jet-secret-beach-tour",
      category: "Tour",
      title: "ジェットでしか辿り着けない本当の宮古島に出会えるツアー",
      text: "ユニの浜とジェットでしか行けない秘境ビーチへ。ドローン撮影付きのプライベートツアーを紹介。",
      date: "2026.07.25",
      readTime: "5分",
      image: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
      tags: [
        "#宮古島",
        "#ジェット",
        "#秘境",
        "#シークレットビーチ",
        "#マリンアクティビティ",
        "#ドローン",
        "#撮影",
      ],
    },
    {
      id: "tour-1",
      slug: "miyakojima-surfing",
      category: "Tour",
      title: "宮古島でサーフィンをするべき理由3選",
      text: "人が少ない海、宮古ブルーでの撮影、ローカルガイド付きの安心感。宮古島サーフィンの魅力を紹介。",
      date: "2026.07.19",
      readTime: "5分",
      image: img(
        "v1784354836/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-18_15.06.59_noluwe.png",
      ),
      tags: [
        "#宮古島",
        "#サーフィン",
        "#マリンアクティビティ",
        "#撮影",
        "#ドローン",
      ],
    },
    {
      id: "tour-2",
      slug: "tour",
      category: "Tour",
      title: "宮古島の映えツアーでできること",
      text: "写真、動画、ドローン撮影まで、普通の観光では残せない体験を紹介。",
      date: "2026.06.25",
      readTime: "5分",
      image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
      tags: ["#宮古島", "#撮影", "#ドローン", "#旅動画"],
    },
    {
      id: "tour-5",
      slug: "one-day-photogenic-tour-experience",
      category: "Tour",
      title: "秘境フォトツアーの様子を紹介",
      text: "秘境スポット巡り、撮影、ドローン撮影まで。秘境フォトツアー当日の雰囲気を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
      tags: ["#宮古島", "#秘境フォトツアー", "#ツアーの様子", "#ドローン"],
    },
    {
      id: "tour-6",
      slug: "hidden-sup-tour-experience",
      category: "Tour",
      title: "秘境SUPツアーの様子を紹介",
      text: "人が少ない海でSUPを楽しむ、秘境SUPツアーの流れと撮影の雰囲気を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784734130/DJI_20260722152642_0033_D_tb9qki.webp"),
      tags: ["#宮古島", "#SUP", "#秘境", "#ツアーの様子"],
    },
    {
      id: "tour-7",
      slug: "jet-private-secret-tour-experience",
      category: "Tour",
      title: "ジェットツアーの様子を紹介",
      text: "ユニの浜とジェットでしか行けない秘境ビーチへ向かう、特別なツアーの様子を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
      tags: ["#宮古島", "#ジェット", "#秘境", "#ツアーの様子"],
    },
    {
      id: "tour-8",
      slug: "yabiji-hidden-paradise",
      category: "Tour",
      title: "人生で一度は行きたい秘境・八重干瀬",
      text: "船で向かう特別な海、八重干瀬。透明度とサンゴ礁の魅力を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg"),
      tags: ["#宮古島", "#八重干瀬", "#秘境", "#マリンアクティビティ"],
    },
    {
      id: "tour-9",
      slug: "how-to-visit-secret-beaches",
      category: "Tour",
      title: "まだ誰も行ったことがない秘境に行く方法",
      text: "観光客が少ない秘境やシークレットビーチへ、安全に行くための考え方を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
      tags: ["#宮古島", "#秘境", "#シークレットビーチ", "#非日常体験"],
    },
    {
      id: "tour-10",
      slug: "miyakojima-starry-sky-spots",
      category: "Tour",
      title: "宮古島で満天の星空を見るには？おすすめ星空スポット",
      text: "新月前後、月明かり、街灯の少ない場所など、満天の星空を見る条件とスポットを紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
      tags: ["#宮古島", "#星空", "#星空スポット", "#星空撮影"],
    },
  ],

  star: [
    {
      id: "star-1",
      slug: "miyakojima-starry-sky-spots",
      category: "Star",
      title: "宮古島で満天の星空を見るには？おすすめ星空スポット",
      text: "新月前後、月明かり、街灯の少ない場所など、満天の星空を見る条件とスポットを紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
      tags: ["#宮古島", "#星空", "#星空スポット", "#星空撮影"],
    },
    {
      id: "star-2",
      slug: "miyakojima-starry-season-2026",
      category: "Star",
      title:
        "宮古島の星空が綺麗に見える時期は？おすすめ日程・天の川情報【2026年版】",
      text: "新月前後、月明かり、天の川シーズン、2026年の星空フォトおすすめ日程を紹介。",
      date: "2026.07.31",
      readTime: "8分",
      image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
      tags: ["#宮古島", "#星空", "#天の川", "#新月"],
    },
    {
      id: "star-3",
      slug: "miyakojima-today-travel-dashboard",
      category: "Star",
      title: "宮古島を120%楽しむために！今日チェックしたい旅情報",
      text: "天気、日の出・日の入り、月の出・月入り、潮位、星空指数など出発前に見る情報を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#天気", "#潮位", "#星空"],
    },
  ],

  shooting: [
    {
      id: "shooting-girls-trip-1",
      slug: "girls-trip-photo-movie-miyakojima",
      category: "Shooting",
      title: "宮古島女子旅で絶対に残したい写真と映像",
      text: "宮古島 女子旅 写真で探している方へ。SUPでしか来れない秘境やシークレットビーチで、SNSに載せたくなる写真・動画を残す旅。",
      date: "2026.08.08",
      readTime: "5分",
      image: img("v1786120675/DSC00888_tk8uhe.webp"),
      tags: [
        "#宮古島",
        "#宮古島女子旅",
        "#女子旅",
        "#撮影",
        "#秘境SUP",
        "#秘境",
        "#SUP",
        "#シークレットビーチ",
        "#完全プライベート",
        "#非日常体験",
        "#映え",
      ],
    },
    {
      id: "shooting-cafe-1",
      slug: "bae-cafe-best5",
      category: "Shooting",
      title: "写真撮るならここ！映えるカフェBEST6",
      text: "宮古島で写真や動画に残したい、海・緑・南国感がきれいに映えるカフェを厳選。",
      date: "2026.07.22",
      readTime: "6分",
      image: img(
        "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
      ),
      tags: ["#宮古島", "#カフェ巡り", "#映えスポット", "#撮影"],
    },
    {
      id: "shooting-drive-1",
      slug: "drive-scenic-spots",
      category: "Shooting",
      title: "宮古島で車で行ける絶景スポット9選",
      text: "ドライブで行ける絶景から、サンセットが綺麗に見える場所まで。宮古島旅行で立ち寄りたいスポットを紹介。",
      date: "2026.06.20",
      readTime: "7分",
      image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
      tags: [
        "#宮古島",
        "#ドライブ",
        "#サンセット",
        "#映えスポット",
        "#ドローン",
        "#撮影",
      ],
    },
    {
      id: "shooting-drive-2",
      slug: "miyakojima-superb-view-spots",
      category: "Shooting",
      title: "宮古島旅行で絶対に行きたい絶景スポット",
      text: "王道の絶景から秘境スポット、究極の非日常体験を残せる秘境フォトツアーまで紹介。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: [
        "#宮古島",
        "#絶景スポット",
        "#秘境フォトツアー",
        "#撮影",
        "#ドローン",
      ],
    },
    {
      id: "shooting-beach-1",
      slug: "beach-best5",
      category: "Shooting",
      title: "初めての宮古島で行きたいビーチ5選",
      text: "与那覇前浜、砂山、17ENDなど、初めてでも行きやすく写真に残したいビーチを厳選。",
      date: "2026.07.22",
      readTime: "6分",
      image: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
      tags: ["#宮古島", "#ビーチ", "#映えスポット", "#撮影"],
    },
    {
      id: "shooting-tour-1",
      slug: "drone-photo-spots",
      category: "Shooting",
      title: "宮古島でドローン撮影したい絶景スポット5選",
      text: "宮古ブルーの海、橋、サンセットまで、空から残すと映えるスポットを紹介。",
      date: "2026.07.22",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#ドローン", "#撮影", "#映えスポット"],
    },
    {
      id: "shooting-tour-2",
      slug: "miyakojima-surfing",
      category: "Shooting",
      title: "宮古島でサーフィンをするべき理由3選",
      text: "人が少ない海、宮古ブルーでの撮影、ローカルガイド付きの安心感。宮古島サーフィンの魅力を紹介。",
      date: "2026.07.19",
      readTime: "5分",
      image: img(
        "v1784354836/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-18_15.06.59_noluwe.png",
      ),
      tags: [
        "#宮古島",
        "#サーフィン",
        "#マリンアクティビティ",
        "#撮影",
        "#ドローン",
      ],
    },
    {
      id: "shooting-tour-3",
      slug: "jet-secret-beach-tour",
      category: "Shooting",
      title: "ジェットでしか辿り着けない本当の宮古島に出会えるツアー",
      text: "ユニの浜とジェットでしか行けない秘境ビーチへ。ドローン撮影付きのプライベートツアーを紹介。",
      date: "2026.07.25",
      readTime: "5分",
      image: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
      tags: [
        "#宮古島",
        "#ジェット",
        "#秘境",
        "#シークレットビーチ",
        "#マリンアクティビティ",
        "#ドローン",
        "#撮影",
      ],
    },
    {
      id: "shooting-tour-5",
      slug: "one-day-photogenic-tour-experience",
      category: "Shooting",
      title: "秘境フォトツアーの様子を紹介",
      text: "秘境スポット巡り、撮影、ドローン撮影まで。秘境フォトツアー当日の雰囲気を紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
      tags: ["#宮古島", "#秘境フォトツアー", "#ツアーの様子", "#ドローン"],
    },
    {
      id: "shooting-drive-3",
      slug: "ultimate-extraordinary-miyakojima",
      category: "Shooting",
      title: "全てを忘れ究極の非日常体験を求める方へ",
      text: "秘境の海、絶景撮影、SUP、ジェット、星空まで。宮古島の究極の過ごし方を紹介。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
      tags: ["#宮古島", "#非日常体験", "#秘境", "#秘境フォトツアー"],
    },
  ],

  gourmet: [
    {
      id: "gourmet-8",
      slug: "miyakojima-night-dinner-guide",
      category: "Gourmet",
      title: "宮古島のおすすめ夜ご飯｜雰囲気別ガイド",
      text: "島おでん、民謡居酒屋、海鮮、宮古牛、しゃぶしゃぶまで。営業時間・定休日・価格帯つきで紹介。",
      date: "2026.09.10",
      readTime: "8分",
      image: img("v1789053600/IMG_6917-edited_u83koj.jpg"),
      tags: ["#宮古島", "#宮古島グルメ", "#夜ご飯", "#居酒屋"],
    },
    {
      id: "gourmet-4",
      slug: "night-dinner-top5",
      category: "Gourmet",
      title: "宮古島の夜ご飯TOP5",
      text: "島おでん、民謡居酒屋、ローカル居酒屋、宮古牛まで。宮古島旅行の夜に行きたいお店を厳選。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1789053600/IMG_6917-edited_u83koj.jpg"),
      tags: ["#宮古島", "#グルメ", "#夜ご飯", "#夜遊び"],
    },
    {
      id: "gourmet-6",
      slug: "miyakojima-yakiniku-top3",
      category: "Gourmet",
      title: "宮古島焼肉店TOP3",
      text: "宮古牛を楽しめる焼肉店を、旅行中に選びやすい価格帯の目安つきで紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1789053600/IMG_6917-edited_u83koj.jpg"),
      tags: ["#宮古島", "#グルメ", "#焼肉", "#宮古牛"],
    },
    {
      id: "gourmet-7",
      slug: "miyakojima-sweets-best14",
      category: "Gourmet",
      title: "宮古島スイーツ特集 14選",
      text: "スムージー、マンゴー、さたぱんびん、アイス、ドーナツまで。宮古島旅行で立ち寄りたいスイーツ店を紹介。",
      date: "2026.07.31",
      readTime: "8分",
      image: img("v1784690818/23_mbegc4.png"),
      tags: ["#宮古島", "#グルメ", "#スイーツ", "#宮古島スイーツ"],
    },
    {
      id: "gourmet-5",
      slug: "miyakojima-gelato-best5",
      category: "Gourmet",
      title: "宮古島でジェラート食べるならここ5選",
      text: "リッコジェラート、Ninufa、ブルーシールなど、宮古島旅行中に立ち寄りたい冷たいスイーツを紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img(
        "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
      ),
      tags: ["#宮古島", "#グルメ", "#ジェラート", "#スイーツ"],
    },
    {
      id: "gourmet-1",
      slug: "gourmet",
      category: "Gourmet",
      title: "宮古島のおすすめグルメ＆ご当地グルメ8選",
      text: "宮古そば、島野菜、マンゴーなど、旅で食べたいグルメを紹介。",
      date: "2026.06.12",
      readTime: "6分",
      image: img("v1784689797/soba_yyrxly.jpg"),
      tags: ["#宮古島"],
    },
  ],

  dinner: [
    {
      id: "dinner-3",
      slug: "miyakojima-night-dinner-guide",
      category: "Dinner",
      title: "宮古島のおすすめ夜ご飯｜雰囲気別ガイド",
      text: "島おでん、民謡居酒屋、海鮮、宮古牛、しゃぶしゃぶまで。営業時間・定休日・価格帯つきで紹介。",
      date: "2026.09.10",
      readTime: "8分",
      image: img("v1784292789/DSC00325_htmozu.jpg"),
      tags: ["#宮古島", "#宮古島グルメ", "#夜ご飯", "#居酒屋"],
    },
    {
      id: "dinner-1",
      slug: "night-dinner-top5",
      category: "Dinner",
      title: "宮古島の夜ご飯TOP5",
      text: "島おでん、民謡居酒屋、ローカル居酒屋、宮古牛まで。宮古島旅行の夜に行きたいお店を厳選。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784292789/DSC00325_htmozu.jpg"),
      tags: ["#宮古島", "#グルメ", "#夜ご飯", "#夜遊び"],
    },
    {
      id: "dinner-2",
      slug: "miyakojima-yakiniku-top3",
      category: "Dinner",
      title: "宮古島焼肉店TOP3",
      text: "宮古牛を楽しめる焼肉店を、旅行中に選びやすい価格帯の目安つきで紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784292789/DSC00325_htmozu.jpg"),
      tags: ["#宮古島", "#グルメ", "#夜ご飯", "#焼肉", "#宮古牛"],
    },
  ],

  night: [
    {
      id: "night-6",
      slug: "miyakojima-night-dinner-guide",
      category: "Night",
      title: "宮古島のおすすめ夜ご飯｜雰囲気別ガイド",
      text: "島おでん、民謡居酒屋、海鮮、宮古牛、しゃぶしゃぶまで。営業時間・定休日・価格帯つきで紹介。",
      date: "2026.09.10",
      readTime: "8分",
      image: img("v1784292789/DSC00325_htmozu.jpg"),
      tags: ["#宮古島", "#宮古島グルメ", "#夜ご飯", "#居酒屋"],
    },
    {
      id: "night-5",
      slug: "full-moon-party-japan-miyakojima",
      category: "Night",
      title: "日本に存在するフルムーンパーティとは？",
      text: "満月の夜に白をまとって集う、宮古島らしい非日常ナイトイベントを紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
      tags: ["#宮古島", "#フルムーンパーティ", "#夜遊び", "#非日常体験"],
    },
    {
      id: "night-3",
      slug: "night-dinner-top5",
      category: "Night",
      title: "宮古島の夜ご飯TOP5",
      text: "島おでん、民謡居酒屋、ローカル居酒屋、宮古牛まで。宮古島旅行の夜に行きたいお店を厳選。",
      date: "2026.07.31",
      readTime: "6分",
      image: img("v1784292789/DSC00325_htmozu.jpg"),
      tags: ["#宮古島", "#グルメ", "#夜ご飯", "#夜遊び"],
    },
    {
      id: "night-4",
      slug: "miyakojima-yakiniku-top3",
      category: "Night",
      title: "宮古島焼肉店TOP3",
      text: "宮古牛を楽しめる焼肉店を、旅行中に選びやすい価格帯の目安つきで紹介。",
      date: "2026.07.31",
      readTime: "5分",
      image: img("v1784292789/DSC00325_htmozu.jpg"),
      tags: ["#宮古島", "#グルメ", "#焼肉", "#宮古牛", "#夜ご飯"],
    },
    {
      id: "night-1",
      slug: "night",
      category: "Night",
      title: "宮古島の夜を楽しむスポットまとめ",
      text: "夜カフェ、バー、星空など、夜の宮古島を楽しむ過ごし方。",
      date: "2026.06.09",
      readTime: "5分",
      image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
      tags: ["#宮古島"],
    },
    {
      id: "night-2",
      slug: "star",
      category: "Star",
      title: "宮古島の星空が綺麗な場所まとめ",
      text: "街明かりが少なく、星空を楽しみやすいスポットを紹介。",
      date: "2026.06.15",
      readTime: "5分",
      image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
      tags: ["#宮古島", "#撮影"],
    },
  ],

  shisha: [
    {
      id: "shisha-1",
      slug: "shisha",
      category: "Shisha",
      title: "宮古島でゆっくり過ごせるシーシャスポット",
      text: "雨の日や夜に、ゆっくり過ごしたい人向けのスポットを紹介。",
      date: "2026.06.07",
      readTime: "4分",
      image: img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg"),
      tags: ["#宮古島"],
    },
  ],
};

export const getAllBlogIndexArticles = () => {
  const articles = Object.values(categoryArticles)
    .flat()
    .filter(isVisibleArticle);
  const uniqueArticles = new Map();

  articles.forEach((article) => {
    const key = article.slug || article.id;

    if (!uniqueArticles.has(key)) {
      uniqueArticles.set(key, article);
    }
  });

  return Array.from(uniqueArticles.values());
};

export const getArticlesByTag = (tagKey) => {
  const normalizedTag = decodeURIComponent(tagKey || "").replace("#", "");

  return getAllBlogIndexArticles().filter((article) => {
    const tags = Array.isArray(article.tags) ? article.tags : [];

    return tags.some((tag) => tag.replace("#", "") === normalizedTag);
  });
};
